import type { ReactNode } from 'react';
import React from 'react';

import Error from './error';

type InputWrapperProps = {
  children: ReactNode;
  required?: boolean;
  htmlFor?: string;
  label?: string;
  error?: string;
};

const InputWrapper = ({ children, error, htmlFor, label, required }: InputWrapperProps) => {
  return (
    <div className="flex size-full flex-col justify-items-start gap-1">
      {label && (
        <label className="mb-1 text-sm font-medium text-black dark:text-white" htmlFor={htmlFor}>
          {`${label}${required ? ' *' : ''}`}
        </label>
      )}
      {children}
      {error && <Error error={error} />}
    </div>
  );
};

export default InputWrapper;
